// extracted by mini-css-extract-plugin
export default {"icon":"chat-list-button-module--icon--29891","text":"chat-list-button-module--text--f9de6"};